import { render, staticRenderFns } from "./quiz-history.html?vue&type=template&id=70113e3e&scoped=true&"
import script from "./quiz-history.js?vue&type=script&lang=js&"
export * from "./quiz-history.js?vue&type=script&lang=js&"
import style0 from "./quiz-history.css?vue&type=style&index=0&id=70113e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70113e3e",
  null
  
)

export default component.exports